import { useState, useEffect } from 'react';

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

import { handleHttpErrorStatus } from '../../../../../../utils/handleHttpErrorStatus';
import { durationMap } from '../../durationMap';
import { labelStyles } from '../../../../../../common/styles/formStyles';
import Grid from '@mui/material/Grid';
import {hetch} from "../../../../../../utils/fetch.hooked";

function AddNotificationSettingForm({ triggerRefetch, handleClose }) {
  const [durationsList, setDurationsList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [formValues, setFormValues] = useState({count: '', durationId: ''});
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (evt) => {
    const { name, value } = evt.target;
    setFormValues({
      ...formValues,
      [name]: `${value}`.replace(/[^0-9]/g, ''),
    });
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setSubmitted(true);
    setError('');

    if (Object.values(formValues).every((value) => value)) {
      setIsFetching(true);
      hetch('/api/notification_settings', {
        headers: {'Content-Type': 'application/json'},
        method: 'POST',
        body: JSON.stringify({
          count: +formValues.count,
          duration_id: +formValues.durationId
        }),
      })
        .then(handleHttpErrorStatus)
        .then(() => {
          handleClose();
          triggerRefetch();
        })
        .catch(err => err.json())
        .then(res => {
          if (res) {
            setError(res.message);
          }
        })
        .finally(() => {
          setIsFetching(false);
        });
    }
  };

  useEffect(() => {
    const fetchData = () => {
      hetch('/api/durations')
        .then(res => res.json())
        .then(res => {
          setDurationsList(res?.content ?? []);
        });
    }

    fetchData();
  }, []);

  useEffect(() => {
    const {durationId, count} = formValues;
    const maxValue = durationsList.find((duration) => duration.id === Number(durationId))?.maxValue;
    if (count > maxValue) {
      setFormValues((prevState) => ({
        ...prevState,
        count: maxValue,
      }))
    }
  }, [formValues.durationId, formValues.count]);

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {error ? (
          <Grid item xs={12}>
            <Alert severity="error">{error}</Alert>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <InputLabel htmlFor='count' sx={labelStyles} required={true}>
            За какое количество единиц времени уведомлять
          </InputLabel>
          <TextField
            id='count'
            name='count'
            type='text'
            fullWidth={true}
            size="small"
            error={submitted && !formValues.count}
            disabled={isFetching}
            value={formValues.count}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel
            htmlFor='durationId'
            sx={labelStyles}
            required={true}
          >
            Единица измерения времени
          </InputLabel>
          <Select
            id='durationId'
            name='durationId'
            size="small"
            fullWidth
            disabled={!durationsList.length || isFetching}
            error={submitted && !formValues.durationId}
            value={formValues.durationId}
            onChange={handleInputChange}
          >
            {durationsList.map(item => (
              <MenuItem
                sx={{ fontSize: '0.875rem' }}
                key={item.id}
                value={item.id}
              >
                {durationMap[item.id]}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Button
            title="Сохранить настройку уведомлений"
            variant='contained' type='submit'
            disabled={isFetching}
          >
            Сохранить
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default AddNotificationSettingForm;
